import React from "react";
import MapChartES from "../MapGraph/indexES";
import MapChartPT from "../MapGraph/index";
import MapChartIRL from "../MapGraph/indexIRL";


function getCountryFromHost() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host.includes("pt")) return "PT";
    if (host.includes("ie")|| host.includes("app")) return "IRL";
  }
  return "ES";
}


interface MapChartProps {
    setTooltipContent: any;
    values: number[];
    className?: string;
    loading?: boolean;
}

export default function MapChartSwitcher(props: MapChartProps) {
    const country = getCountryFromHost();
  if (country === "PT") return <MapChartPT {...props} />;
  if (country === "IRL") return <MapChartIRL {...props} />;
  return <MapChartES {...props} />;
}